<template>
    <div>
        Please use <a :href="loginOpenIDUrl">the Login link</a> if you aren't forwarded to login
        page.
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import defaultRouteMixin from '../mixins/default-route-mixin';

export default {
    mixins: [defaultRouteMixin],
    computed: {
        ...mapState('context', ['loginRedirectUrl']),
        returnPath() {
            let returnPath =
                this.defaultRoute !== '/'
                    ? this.defaultRoute
                    : this.currentReturnPathRoute || this.defaultRoute;
            if (returnPath === '/auth-openid/login') returnPath = this.defaultRoute;
            return returnPath;
        },
        loginOpenIDUrl() {
            this.setCurrentLoginMethod('auth-openid');
            const query = new URLSearchParams({ returnPath: this.returnPath });
            return `${this.loginRedirectUrl}/api/auth-openid/login?${query.toString()}`;
        },
        currentContextEntries() {
            return Object.entries(this.$store.state.context);
        },
    },

    created() {
        window.location.href = this.loginOpenIDUrl;
    },

    methods: {
        ...mapActions('context', ['setCurrentLoginMethod']),
    },
};
</script>
